import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faPowerOff,
    faCog,
    faPlusCircle,
    faTrashAlt,
    faCode,
    faColumns,
    faGlobe,
    faCogs,
    faCubes,
    faStroopwafel,
    faEdit,
    faCheckCircle,
    faExchangeAlt,
    faSync,
    faLock,
    faUnlock,
    faUserShield,
    faUser,
    faUndo,
    faLink,
    faUpload,
    faPencilAlt,
    faSpinner,
    faSearch,
    faChevronDown,
    faChevronRight,
    faCheckSquare,
    faSquare,
    faFilter,
    faTimes,
    faArrowCircleLeft,
    faQuestionCircle as faSolidQuestionCircle,
    faArrowCircleRight,
    faArrowCircleUp,
    faArrowCircleDown,
    faTrash,
    faCheck,
    faBars,
    faPlay,
    faExclamationTriangle,
    faExclamationCircle,
    faInfoCircle,
    faSms,
    faEnvelope,
    faCircle,
    faReply,
    faBan,
    faDownload,
    faCopy,
    faCar,
    faTimesCircle,
    faDollarSign,
    faPaperPlane,
    faComment,
    faEnvelopeOpen,
    faPrint,
    faAngleLeft,
    faCaretDown,
    faCaretUp,
    faFileExport,
    faAngleRight,
    faRedoAlt,
    faUndoAlt,
    faCropAlt,
    faCamera,
    faBarcode,
    faCommentDots,
    faArrowsUpDownLeftRight,
    faRecycle,
    faMoon,
    faSun as faSolidSun,
    faSignOut,
    faUpRightFromSquare as faSolidUpRightFromSquare,
    faTasks,
    faHistory as faSolidHistory
} from '@fortawesome/free-solid-svg-icons'

import {
    faQuestionCircle,
    faFolderOpen,
    faWindowRestore,
    faListAlt,
    faFilePdf,
    faImage,
    faSave,
    faStickyNote,
    faCalendarCheck,
    faFileAlt as farFileAlt,
    faTrashAlt as farTrashAlt,
    faCircle as farCircle
} from '@fortawesome/free-regular-svg-icons'

import {
    faRev,
    faJs,
    faCss3Alt,
    faFacebookMessenger,
    faFacebook,
    faGoogle
} from '@fortawesome/free-brands-svg-icons'

import {
    faBrowser,
    faCubes as faCubesRegular,
    faCube,
    faCog as faCogRegularPro,
    faPalette,
    faArrowsV,
    faFolder,
    faEye,
    faEyeSlash,
    faFileChartLine,
    faFilterSlash
} from '@fortawesome/pro-regular-svg-icons'

import {
    faGlobe as faGlobeLight,
    faCogs as faCogsLight,
    faFileAlt,
    faColumns as faLightColumns,
    faTimesCircle as faLightTimesCircle,
    faFileCertificate as faLightFileCertificate,
} from '@fortawesome/pro-light-svg-icons'

import { faQuestionCircle as faDuoQuestionCircle } from '@fortawesome/pro-duotone-svg-icons'

import {
    faPrint as faProPrint,
    faFolderGear
} from '@fortawesome/pro-solid-svg-icons'


import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'

import '@progress/kendo-theme-bootstrap/dist/all.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css'

import App from './App'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import store from 'state/store'

library.add(
    faPowerOff,
    faQuestionCircle,
    faCog,
    faPlusCircle,
    faTrashAlt,
    faBrowser,
    faCode,
    faCubes,
    faCube,
    faGlobeLight,
    faCogs,
    faFolderOpen,
    faFileAlt,
    faColumns,
    faLightColumns,
    faPalette,
    faCogRegularPro,
    faGlobe,
    faCogsLight,
    faCubesRegular,
    faStroopwafel,
    faEdit,
    faLightTimesCircle,
    faCheckCircle,
    faExchangeAlt,
    faArrowsV,
    faRev,
    faJs,
    faCss3Alt,
    faSync,
    faWindowRestore,
    faListAlt,
    faLock,
    faUndo,
    faUnlock,
    faUserShield,
    faUser,
    faFilePdf,
    faLink,
    faUpload,
    faPencilAlt,
    faImage,
    faSpinner,
    faSearch,
    faFolder,
    faChevronDown,
    faChevronRight,
    faCheckSquare,
    faSquare,
    faLightFileCertificate,
    faFilter,
    faTimes,
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowCircleUp,
    faArrowCircleDown,
    faEye,
    faEyeSlash,
    faDuoQuestionCircle,
    faSolidQuestionCircle,
    faQuestionCircle,
    faTrash,
    faCheck,
    faSave,
    faBars,
    faPlay,
    faExclamationTriangle,
    faExclamationCircle,
    faInfoCircle,
    faSms,
    faEnvelope,
    faFacebookMessenger,
    faFacebook,
    faCircle,
    faReply,
    faBan,
    faGoogle,
    faDownload,
    faCopy,
    faCar,
    faTimesCircle,
    faDollarSign,
    faFileChartLine,
    faPaperPlane,
    faComment,
    faEnvelopeOpen,
    faStickyNote,
    faCalendarCheck,
    faPrint,
    farFileAlt,
    farTrashAlt,
    faAngleLeft,
    faCaretDown,
    faCaretUp,
    faFileExport,
    faAngleRight,
    faRedoAlt,
    faUndoAlt,
    faCropAlt,
    faProPrint,
    faCamera,
    faBarcode,
    faCommentDots,
    farCircle,
    faArrowsUpDownLeftRight,
    faRecycle,
    faMoon,
    faSolidSun,
    faSignOut,
    faFolderGear,
    faFilterSlash,
    faSolidUpRightFromSquare,
    faTasks,
    faSolidHistory
)

// get rid of console logs in production build
if (process.env.NODE_ENV === 'production')
    // eslint-disable-next-line @typescript-eslint/naming-convention, no-console
    console.log = function no_console() { }

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
